import { COLUMN_CONTROLLER, COLUMN_DOORS_COUNT, COLUMN_FIXED_ADDRESS, COLUMN_IP_ADDRESS, COLUMN_NAME, COLUMN_SITE, COLUMN_TYPE, COLUMN_LICENSED, COLUMN_MUSTERING_POINT, COLUMN_READER_SERIAL } from "../../constants/column-types";
import { FILTER_DOORS, FILTER_SITES } from "../../constants/filter-types";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { Translator } from "../../contexts/translator";
import { TableColumn } from "../table/TableColumn";

const LiftReaderColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "devName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        isNumeric: false,
        id: 1,
        sortByName: "devFixedAddr",
        sortDirection: "asc",
        active: true,
        translationKey: "fixedAddress",
        columnId: COLUMN_FIXED_ADDRESS,
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        isNumeric: false,
        id: 2,
        sortByName: "devIpAddress",
        sortDirection: "asc",
        active: true,
        translationKey: "ipAddress",
        columnId: COLUMN_IP_ADDRESS,
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 3,
        sortByName: "unitType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Controller",
        accessor: "controller",
        isNumeric: false,
        id: 5,
        sortDirection: "asc",
        active: true,
        translationKey: "controller",
        columnId: COLUMN_CONTROLLER,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 4,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: false,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        columnId: COLUMN_SITE,
        settingDataName: "site"
    }
];


export default LiftReaderColumns;
